let _this;
let editorItem;
let uploadImg = window.location.href.indexOf("topnews.cn") >= 0 || window.location.href.indexOf("topnews.cn") >= 0 ?
  "https://obs.dingxinwen.cn/video/20220626/f514bcbbc794acb60c862cb58d67c568.gif" : "https://obs.dingnews.net/image/20230321/f514bcbbc794acb60c862cb58d67c568.gif";
import "./media";
import "./indent2em";
import "./tabbarSky";
import "./insertTel";
import "./uploadImg";
import "./uploadVideo";
import "./uploadAudio";
import "./insertLink";
import "./expansion";
import "./polish";
import "./tone";
import "./openAi";
import "../../public/tinymce/plugin";
import "./clear-html";
import "./formatpainter.min";
import request from "./libs/request";
import { of, from } from "rxjs";
import { pipe, catchError } from "rxjs/operators";
import { HS_upload } from "./huoshanUpload";
import { Message } from 'element-ui';
import { HSUPLOAD_HOST } from "../constants/apiHosts";
export default {
  setting: {
    language_url: require("@/assets/tinymce/langs/zh_CN.js"),
    language: "zh_CN", //以上两者都需要配置
    branding: false, //是否禁用Powered by TinyMCE
    menubar: false, //"tools table format view insert edit"
    auto_focus: true,
    toolbar:
      "undo redo clear-html formatpainter | bold italic backcolor forecolor hr indent2em alignleft alignment | uploadImg uploadVideo insertTopic mediainsert | openAi", //bullist numlist table blockquote fontsizeselect image media tpImportword code axupimgs
    plugins:
      "code toc fullpage nonbreaking insertdatetime insertdatetime visualchars visualblocks visualblocks searchreplace searchreplace spellchecker pagebreak anchor hr preview print paste charmap help fullscreen table lists colorpicker textcolor link indent2em toolbarsticky autoresize axupimgs clear-html imagetools insertTel uploadImg uploadVideo uploadAudio image media formatpainter insertLink quickbars expansion polish tone openAi", //autosave insertTopic tpImportword
    toolbar_groups: {
      alignment: {
        icon: 'more-drawer',
        tooltip: '更多',
        items: 'aligncenter alignright alignjustify underline strikethrough',
      },
      mediainsert: {
        icon: 'more-drawer',
        tooltip: '更多',
        items: 'uploadAudio insertLink insertTel searchreplace',
      },
    },
    automatic_uploads: true,
    autoresize_bottom_margin: 50,
    autoresize_on_init: true,
    media_live_embeds: true,
    quickbars_insert_toolbar: "",
    quickbars_selection_toolbar:
      "expansion polish tone | bold italic forecolor backcolor | alignleft aligncenter alignright",
    quickbars_image_toolbar: "",
    media_live_embeds: true, //实时预览开关,视频相关
    file_picker_types: "image media", //视频需要file
    fontsize_formats: "12px 14px 16px 18px 24px 36px",
    contextmenu: false, // 右键菜单
    image_description: false, // 图片标题
    image_caption: true, // 图片描述
    image_dimensions: false, // 显示隐藏图片尺寸
    media_alt_source: false, // 视频备用地址
    image_uploadtab: false, // 图片对话框中上传标签开关
    inline: true,
    fixed_toolbar_container: '#external-toolbar',
    //toolbar_mode: 'floating',
    //toolbar_sticky: true, // tabbar吸顶开关
    //cfyun_toolbar_sticky: true, // tabbar吸顶开关
    //toolbar_sticky_wrap: ".memberContainer",
    //toolbar_sticky_elem_height: 0, // 容器头部距离
    // content_style:
    //   "body{margin: 0;overflow-x:hidden;}p{font-size: 18px !important;color: #333;line-height: 1.71 !important;margin-top: 15px;max-width: 100% !important;overflow-x: hidden;}section{font-size: 18px !important;color: #333;line-height: 1.71 !important;max-width: 100% !important;overflow-x: hidden;}div{font-size: 18px !important;color: #333;line-height: 1.71 !important;}figure{width:100%;margin: 15px 0 0 0;}img{height:auto;display:block;max-width: 100% !important;margin: 0 auto !important;}span{font-size: 18px !important;color: #333; line-height: 1.71 !important;}.get-cover p{width: 100%;height: 24px;text-align: center;color: #bbb;margin-top: 0 !important;}.get-cover{width: 100%;min-height: 264px;border: 1px solid #e8e8e8;background-color: #fcfcfc;border-radius: 4px;display: flex;justify-content: center;align-items: center;margin-top: 20px;position: relative;}.get-cover .tip {position: absolute;left: 0;bottom: -1px;font-size: 12px !important;color: #fff;width: 100%;line-height: 32px !important;text-align: center;background-color: rgba(0,0,0,.32);border-radius: 4px;}.get-cover .videoIcon{width:40px;height:40px;min-height: 40px;position:absolute;left:50%;top:50%;margin:-20px 0 0 -20px !important;}section{font-size: 18px !important;color: #333;line-height: 1.7 !important;letter-spacing: 0.8px !important;max-width: 100% !important;}",
    //toolbar_drawer: false, // 工具栏全部展示
    imagetools_cors_hosts: ["obs.dingxinwen.cn", "obs.dingnews.net", "dingduantest.obs.cn-north-4.myhuaweicloud.com", "vod.dingxinwen.cn", "vod.dingnews.net", "image.dingxinwen.cn", "image.dingnews.net", "img.dingxinwen.cn", "img.dingnews.net", "nmvod.dingxinwen.cn", "nmvod.dingnews.net", "att.dahecube.com"],
    imagetools_toolbar: "editimage imageoptions",
    paste_data_images: true, // 拖拽粘贴图片
    object_resizing: true, // 调整大小控件开关
    extended_valid_elements: "dd-audio[*]",
    custom_elements: 'dd-audio',
    icons: 'custom',
    placeholder: '请输入正文',
    //valid_elements: "p,span[class|contenteditable],br,div,section",

    paste_as_text: false, // 默认粘贴为文本
    smart_paste: false, // 识别url、图片等
    paste_enable_default_filters: false, // 开启默认过滤器
    paste_merge_formats: true, // 合并冗余标签
    paste_auto_cleanup_on_paste: true,
    paste_remove_styles: true,
    paste_remove_styles_if_webkit: true,
    paste_strip_class_attributes: true,
    paste_word_valid_elements: 'b,strong,i,em,p,span,br,img,a',
    paste_webkit_styles: 'color text-align text-indent background-color visibility', // 粘贴时要保留的样式
    paste_retain_style_properties: 'color text-align text-indent background-color visibility', // 粘贴时要保留的样式

    init_instance_callback: (editor) => {
      editorItem = editor;

      let editorDoc = tinymce.activeEditor.getDoc();
      let editorBody = editorDoc.head;
      let script = editorDoc.createElement('script');
      script.src = 'https://static.dingxinwen.cn/web-component/quarkc.js';
      script.onload = function () {
        let script1 = editorDoc.createElement('script');
        script1.src = 'https://static.dingxinwen.cn/web-component/index.umd.js';
        editorBody.appendChild(script1);
      }
      editorBody.appendChild(script);

      editor.on('BeforeSetContent', function (e) {
        let reg =
          /(https?|http|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g;
        e.content = e.content.replace(new RegExp(/data-mce-src\=\"http/, "g"),
          'a="');
        e.content = e.content.replace(new RegExp(/fixed;/, "g"),
          'static;');
        e.content = e.content.replace(/\s_src\s*=\s*(["'])(.*?)\1/g, '');
        let clearArray = e.content.match(reg);
        if (clearArray) {
          let imgs = [];

          if (clearArray.length > 0) {
            clearArray.forEach((item1, index1) => {
              if (
                ["gif", "jpg", "jpeg", "png", "GIF", "JPG", "JPEG", "PNG", "img", "image"].some(
                  (item) => {
                    return item1.indexOf(item) >= 0 && item1.indexOf("topnews.cn") < 0 && item1.indexOf("dingnews.net") < 0 && item1.indexOf("dingduantest") < 0 && item1.indexOf("dingxinwen.cn") < 0;
                  }
                )
              ) {
                let videos = ['.mp4', '.mov', '.avi', '.wmv', '.rmvb', '.m4v', '.mkv', '.flv'];
                if (videos.filter(n => item1.toLowerCase().indexOf(n) > -1).length > 0) {

                } else {
                  let htmlArray = e.content.split(item1);
                  e.content = htmlArray.join(uploadImg);
                  imgs.push(item1);
                }
              }
            });
          }

          if (imgs.length) {
            uploadImgFn(imgs, e.content);
          }
        }
      });
    },
    paste_preprocess: function (plugin, args) {
      args.content = args.content.replace(/h1>/gi, "p>");
      args.content = args.content.replace(/h2>/gi, "p>");
      args.content = args.content.replace(/h3>/gi, "p>");
      args.content = args.content.replace(/h4>/gi, "p>");
      args.content = args.content.replace(/<h1/gi, "<p");
      args.content = args.content.replace(/<h2/gi, "<p");
      args.content = args.content.replace(/<h3/gi, "<p");
      args.content = args.content.replace(/<h4/gi, "<p");
      args.content = args.content.replace(/<p><\/p>/gi, "");
      args.content = args.content.replace(/<p><br><\/p>/gi, "");
      args.content = args.content.replace(/<div><\/div>/gi, "");
      args.content = args.content.replace(/<div><br><\/div>/gi, "");
      //args.content = args.content.replace(/data:image\/.*\"/gi, '"');
      args.content = args.content.replace(
        /<img/gi,
        "<img width='100%' height='auto'"
      );
      args.content = args.content.replace(/&amp;wxfrom=[0-9][0-9]?/gi, "").replace(/&amp;wx_co=[0-9][0-9]?/gi, "").replace(/&amp;wx_lazy=[0-9][0-9]?/gi, "").replace(new RegExp(/data-mce-src\=\"http/, "g"),
        'a="').replace(/&amp;tp=wxpic/gi, "").replace(new RegExp(/data-before-oversubscription-url\=\"http/, "g"), 'b="').replace(new RegExp(/data-croporisrc\=\"http/, "g"), 'c="').replace(/&wxfrom=[0-9][0-9]?/gi, "").replace(/&wx_co=[0-9][0-9]?/gi, "").replace(/&wx_lazy=[0-9][0-9]?/gi, "").replace(/@f_auto/gi, "").replace(/;from=appmsg/gi, "").replace(/&quot;/gi, "").replace(/&quot/gi, "").replace(/&tp=webp/gi, "").replace(/&amp;tp=webp/gi, "");
      args.content = args.content.replace(/fixed;/gi, "static;");
      // args.content = args.content.replace(/data-src="[^"]*"/g, '');
      args.content = args.content.replace(/data-authiconurl="[^"]*"/g, '');
      args.content = args.content.replace(/\s_src\s*=\s*(["'])(.*?)\1/g, '');
      args.content = args.content.replace(/height:\s*\d+(\.\d+)?px;/g, '');

      let reg =
        /(https?|http|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g;
      let clearArray = args.content.match(reg);
      if (clearArray) {
        let imgs = [];

        if (clearArray.length > 0) {
          clearArray.forEach((item1, index1) => {
            if (
              ["gif", "jpg", "jpeg", "png", "GIF", "JPG", "JPEG", "PNG", "img", "image"].some(
                (item) => {
                  return item1.indexOf(item) >= 0 && item1.indexOf("topnews.cn") < 0 && item1.indexOf("dingnews.net") < 0 && item1.indexOf("dingduantest") < 0 && item1.indexOf("dingxinwen.cn") < 0;
                }
              )
            ) {
              let videos = ['.mp4', '.mov', '.avi', '.wmv', '.rmvb', '.m4v', '.mkv', '.flv'];
              if (videos.filter(n => item1.toLowerCase().indexOf(n) > -1).length > 0) {

              } else {
                let htmlArray = args.content.split(item1);
                args.content = htmlArray.join(uploadImg);
                imgs.push(item1);
              }
            }
          });
        }
        uploadImgFn(imgs, args.content);
      }

      if (tinymce.activeEditor.getContent().indexOf('wrongWord') < 0) {
        setTimeout(() => {
          for (let i = 0; i < 3; i++) {
            //window.clearHtml(editorItem);
          }
        }, 200)
      }
    },
    video_template_callback: function (data) {
      data.width = "100%";
      data.height = "auto";
      console.log(data);
      return `<p>
                  <span class="mce-preview-object mce-object-video" contenteditable="false" 
                  data-mce-object="video" data-mce-p-allowfullscreen="allowfullscreen" 
                  data-mce-p-frameborder="no" data-mce-p-scrolling="no" 
                  data-mce-p-src=${data.source1} 
                  data-mce-p-width=${data.width} 
                  data-mce-p-height=${data.height} 
                  data-mce-p-controls="controls" data-mce-html="%20" style="width:100%;">
                    <video width=${data.width} height=${data.height} controls="controls">
                    <source src=${data.source1} type=${data.source1mime}></source>
                    </video>
                  </span>
              </p>`;
    },
    //此部分为拖动上传
    images_upload_handler: (blobInfo, success, failure) => {
      let file = new window.File([blobInfo.blob()], "1.jpg", {
        type: "image/jpeg",
      });
      HS_upload(file, (data) => {
        success(data.url);
      },
        (error) => {
          console.log(error);
        }, (processPercent) => {
          console.log("processPercent:" + processPercent);
        })
    },
    file_picker_callback: function (cb, value, meta) {
      if (meta.filetype == "image") {
        let filetype = ".jpg, .jpeg, .png, .gif";
        var input = document.createElement("input");
        input.setAttribute("type", "file");
        input.setAttribute("accept", filetype);
        input.click();
        input.onchange = function (e) {
          let file = this.files[0];
          HS_upload(file, (data) => {
            cb(data.url, {
              width: "100%",
              height: "auto",
            });
          },
            (error) => {
              console.log(error);
            }, (processPercent) => {
              console.log("processPercent:" + processPercent);
            })
        };
      }
    },
  },
  map_callback: function (self) {
    _this = self;
  }
};

function uploadImgFn(clearArray, html) {
  let promiseArr = [];

  setTimeout(() => {
    let htmlNow = tinymce.activeEditor.getContent();
    let htmlSlices = htmlNow.split(uploadImg);
    let uploaded = [];
    let uploadedImgs = [];
    let newHtml = "";

    clearArray.forEach((item, index) => {
      promiseArr.push(
        new Promise((resolve) => {
          from(
            request({
              url: `${HSUPLOAD_HOST}/api/upload/tos/transImage`,
              method: "post",
              data: {
                url: item.replace(/&amp;/gi, "&").replace(/\"/gi, "")
              }
            })
          )
            .pipe(catchError((val) => of(val)))
            .subscribe((val) => {
              if (val.code == 0) {
                uploaded.push(index);
                uploadedImgs[index] = val.data || "";

                resolve();
              } else {
              }
            });
        })
      );
    });

    setTimeout(() => {
      let pro = Promise.allSettled(promiseArr)
      pro.then(data => {
        htmlSlices.forEach((htmlItem, htmlIndex) => {
          if (htmlIndex == htmlSlices.length - 1) {
            newHtml += htmlItem;
          } else if (uploaded.includes(htmlIndex)) {
            newHtml += htmlItem + uploadedImgs[htmlIndex];
          } else {
            newHtml += htmlItem + uploadImg;
          }
        });

        newHtml = newHtml.replace(/data-src=/gi, "src=");

        tinymce.activeEditor.setContent(newHtml.replace(/&amp;tp=wxpic/gi, ""));

        if (tinymce.activeEditor.getContent().indexOf('wrongWord') < 0) {
          setTimeout(() => {
            for (let i = 0; i < 3; i++) {
              //window.clearHtml(editorItem);
            }
          }, 200)
        }

        window.postMessage("pasteImgDone", "*");
      }, err => {
        console.log("失败", err)
      })
    }, 500)
  }, 500);
}
